import React, { useEffect, useState } from "react";
import { ReactComponent as Notification } from "../../svgs/notification.svg";
import { unSeenNotificationCount } from "../../../utils/API/unSeenNotificationCount";
import { viewCurrentNotification } from "../../../utils/API/viewCurrentNotification";
import { useDispatch } from "react-redux";

const LoginOption = ({ userType, openNotifications, setOpenNotifications  }) => {
  const dispatch = useDispatch();
  const userTypeContent = {
    seller: "Seller",
    buyer: "Buyer",
    trader: "Trader",
  };
  const content = userTypeContent[userType];
  const [unSeenNotification, setUnSeenNotification] = useState(0);

  const fetchData = async () => {
    try {
      const response = await unSeenNotificationCount(dispatch);
      setUnSeenNotification(response.data.unreadNotificationCount);
    } catch (error) {
      console.log("Error is : ", error);
    } finally {
    }
  };



  const handleNotificationClick = async () => {
    try {
      // await viewCurrentNotification(dispatch);
      // if(openNotifications){
      //   fetchData();
      // }

      if(!openNotifications){
        if(unSeenNotification >6){
          setUnSeenNotification(unSeenNotification -6)
        }else {
          setUnSeenNotification(0)
        }
      }
      
    } catch (error) {
      console.error("Error updating notification status:", error);
    }
    setOpenNotifications(!openNotifications);
  };

  useEffect(() => {
    const intervalId = setInterval(fetchData, 50000);
    return () => clearInterval(intervalId);
  }, []);
  if (content) {
    return (
      <div className="flex items-center">
        <div className="relative">
          <Notification
            onClick={handleNotificationClick}
            className="mt-1 mr-3 cursor-pointer"
          />
          {unSeenNotification > 0 && (
            <div className="absolute top-0 right-3 bg-red-500 text-white rounded-full w-4 h-4 flex items-center justify-center text-[10px]">
              {unSeenNotification}
            </div>
          )}
        </div>
        <p>{`${content} Log in`}</p>
      </div>
    );
  }

  return null;
};

export default LoginOption;